"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require("react");
var ReactDOM = require("react-dom");
var RV = require("react-virtualized/");
var SortDirection = RV.SortDirection;
var _ = require("underscore");

var TableHeader = function (_React$Component) {
    _inherits(TableHeader, _React$Component);

    function TableHeader() {
        _classCallCheck(this, TableHeader);

        return _possibleConstructorReturn(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).apply(this, arguments));
    }

    _createClass(TableHeader, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this._listenerId = this.props.contextMenu.addListener(ReactDOM.findDOMNode(this), this.props.getHeaderMenuItems(this.props.dataKey), this.props.contextMenu.RIGHT_CLICK);
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            this.props.contextMenu.removeListener(this._listenerId);
            this._listenerId = this.props.contextMenu.addListener(ReactDOM.findDOMNode(this), this.props.getHeaderMenuItems(this.props.dataKey), this.props.contextMenu.RIGHT_CLICK);
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.props.contextMenu.removeListener(this._listenerId);
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                dataKey = _props.dataKey,
                label = _props.label,
                sortBy = _props.sortBy,
                sortDirection = _props.sortDirection;

            var isSortable = this.props.isSortable ? this.props.isSortable(label) : false;
            var rowCount = this.props.isFirstColumn(dataKey) ? "(" + this.props.rowCount + ")" : null;
            var sortClasses = {
                sort: isSortable,
                asc: sortBy === label && sortDirection === SortDirection.ASC,
                desc: sortBy === label && sortDirection === SortDirection.DESC,
                any: isSortable && sortBy !== label,
                ReactVirtualized__Table__headerTruncatedText: true,
                sortArrows: true
            };
            var classes = {
                ReactVirtualized__Table__headerTruncatedText: true
            };
            var isLastColumn = this.props.isLastColumn(dataKey);
            var children = [React.createElement("span", { key: "sorter", className: _.classSet(sortClasses) }), React.createElement(
                "span",
                { className: _.classSet(classes), key: "label", title: label },
                label,
                " ",
                rowCount
            )];

            if (!isLastColumn) {
                children.push(React.createElement("span", { key: "resizeArea", "data-key": dataKey, className: "resizeArea" }));
            }

            return React.createElement(
                "div",
                {
                    style: this.props.columnData ? this.props.columnData.style : null,
                    draggable: "true",
                    onDragStart: function onDragStart(event) {
                        return _this2.props.onDragStart(dataKey, event);
                    },
                    onDrop: function onDrop(event) {
                        return _this2.props.onDrop(dataKey, event);
                    },
                    onDragOver: _.preventDefault
                },
                children
            );
        }
    }]);

    return TableHeader;
}(React.Component);

module.exports = TableHeader;